const DATA_SAVED = "extragestor/alumnos/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/alumnos/RESET_DATA_SAVED";
const ITEM_ADDED = "extragestor/alumnos/ITEM_ADDED";
const ITEM_REMOVED = "extragestor/alumnos/ITEM_REMOVED";
const FETCH_DETALLE = "extragestor/alumnos/FETCH_DETALLE";
const RESET_DETALLE = "extragestor/alumnos/RESET_DETALLE";
const RESET = "extragestor/alumnos/RESET";

/*---*/
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  ITEM_ADDED,
  ITEM_REMOVED,
  RESET,
  FETCH_DETALLE,
  RESET_DETALLE
};



// WEBPACK FOOTER //
// ./src/ducks/alumnos/types.js